module.exports = __webpack_public_path__ + "static/Cookiebot-7ab5dc4a4389854f35b907430b4a8099.jpg";